import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlueCheckmark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 17.1071C13.4775 17.1071 17.1071 13.4775 17.1071 9C17.1071 4.52255 13.4775 0.892857 9 0.892857C4.52255 0.892857 0.892857 4.52255 0.892857 9C0.892857 13.4775 4.52255 17.1071 9 17.1071ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
		fill: "#617ADA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.8634 7.14584L8.30146 12.7077C8.1062 12.903 7.78962 12.903 7.59436 12.7077L4.37622 9.48959L5.08333 8.78248L7.94791 11.6471L13.1562 6.43873L13.8634 7.14584Z",
		fill: "#617ADA"
	})]
});
const ForwardRef = forwardRef(SvgBlueCheckmark);
export { ForwardRef as ReactComponent };
